module.exports = __webpack_public_path__ + "img/logo4.489a46a5.png";